<div id="body-container">
  <div class="background-blue">
    <div class="claims-page-banner container">
      <h1 *ngIf="!isSPOEEnabled" style="font-size:22.5px;"><adp-label labelKey="ClaimsSelectDevice_Title"></adp-label></h1>
      <h1 *ngIf="isSPOEEnabled" style="font-size:22.5px;"><adp-label labelKey="SPOE_ClaimsSelectDevice_Title"></adp-label></h1>
    </div>
  </div>
  <ng-container *ngIf="isSPOEEnabled && !isNative; else default">
    <div class="container pt-4">
      <div style="display:flex;">
        <h2 class="claims-select-title-container" style="margin-top:14px;font-size:35px;">
          <adp-label labelKey="SPOE_ClaimsSelectDevice_HeaderText"></adp-label>
        </h2>
      </div>
    </div>
    <div *ngIf="hasP360MobilePolicy && !hasP360HomeTechPolicy" style="margin-top:40px;">
      <div class="sandbox-mfe-container container">
        <div><h2 style="font-size:24px;font-weight:600 !important;"><adp-label labelKey="Global_Eprism_Product_Name"></adp-label></h2>
        <adp-label labelKey="SPOE_ClaimsSelectDevice_Mobile_SubHeaderText"></adp-label></div>
        <div><pgh-device-inventory [isSelectDeviceView]="true" [deviceViewType]="'EPRISM'"></pgh-device-inventory></div>
      </div>
    </div>

    <div *ngIf="hasP360HomeTechPolicy && !hasP360MobilePolicy" style="margin-top:40px;">
      <div class="sandbox-mfe-container container" style="margin-top:30px;margin-bottom:30px;">
        <div><h2 style="font-size:24px;font-weight:600 !important;"><adp-label labelKey="Global_Product_Name"></adp-label></h2>
          <adp-label labelKey="ClaimsSelectDevice_SubHeaderText"></adp-label></div>
        <div><pgh-device-inventory [isSelectDeviceView]="true" [deviceViewType]="'ELITA'" (handleAddSearchDeviceAction)="handleAddDevice($event);"></pgh-device-inventory></div>
      </div>
    </div>

    <div *ngIf="hasP360HomeTechPolicy && hasP360MobilePolicy" style="margin-top:40px;">
      <div class="sandbox-mfe-container container">
        <div><h2 style="font-size:24px;font-weight:600 !important;"><adp-label labelKey="Global_Eprism_Product_Name"></adp-label></h2>
        <adp-label labelKey="SPOE_ClaimsSelectDevice_Mobile_SubHeaderText"></adp-label></div>
        <div><pgh-device-inventory [isSelectDeviceView]="true" [loadMobileInventoryOnly]="true" [deviceViewType]="'EPRISM'"></pgh-device-inventory></div>
      </div>
      <div class="sandbox-mfe-container container" style="margin-top:30px;margin-bottom:30px;">
        <div><h2 style="font-size:24px;font-weight:600 !important;"><adp-label labelKey="Global_Product_Name"></adp-label></h2>
          <adp-label labelKey="ClaimsSelectDevice_SubHeaderText"></adp-label></div>
        <div><pgh-device-inventory [isSelectDeviceView]="true" [deviceViewType]="'ELITA'" [loadHomeInventoryOnly]="true" (handleAddSearchDeviceAction)="handleAddDevice($event);"></pgh-device-inventory></div>
      </div>
    </div>
  </ng-container>
  <ng-template #default>
    <ng-container>
      <div class="container pt-4">
        <div style="display:flex;">
          <h2 class="claims-select-title-container" style="margin-top:14px;font-size:35px;"><adp-label labelKey="ClaimsSelectDevice_HeaderText"></adp-label>
          </h2>
        </div>
        <div class="claims-select-subtitle-container" style="display:flex;">
        <adp-label labelKey="ClaimsSelectDevice_SubHeaderText"></adp-label>
        </div>
      </div>
      <div class="sandbox-mfe-container container" style="margin-top:14px;">
        <div><pgh-device-inventory [isSelectDeviceView]="true" [deviceViewType]="'ELITA'"></pgh-device-inventory></div>
      </div>
    </ng-container>
  </ng-template>
</div>
